import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error('🚨 ERROR BOUNDARY CAUGHT:');
    console.error('Error:', error);
    console.error('Error Info:', errorInfo);
    this.setState({ error, errorInfo });
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{ 
          padding: '20px', 
          background: '#fee', 
          color: '#c00',
          fontFamily: 'monospace',
          minHeight: '100vh'
        }}>
          <h1>❌ Application Error</h1>
          <h2>Error Details:</h2>
          <pre style={{ background: '#fff', padding: '10px', overflow: 'auto' }}>
            {this.state.error?.toString()}
          </pre>
          <h2>Stack Trace:</h2>
          <pre style={{ background: '#fff', padding: '10px', overflow: 'auto', fontSize: '12px' }}>
            {this.state.error?.stack}
          </pre>
          <h2>Component Stack:</h2>
          <pre style={{ background: '#fff', padding: '10px', overflow: 'auto', fontSize: '12px' }}>
            {this.state.errorInfo?.componentStack}
          </pre>
          <button 
            onClick={() => window.location.reload()}
            style={{ marginTop: '20px', padding: '10px 20px', fontSize: '16px' }}
          >
            🔄 Reload Page
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;